import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { toMilliseconds } from '../Functions/toMilliseconds'
import useWbapiInstance from './useWbapiInstance'

export interface Payer {
  id: number
  name: string
}

export default function usePayers() {
  const { api } = useWbapiInstance()

  const getPayers = async () => {
    const { data } = await api.get(`/api/v1/insurance/payers`)
    return data
  }
  return useQuery<Payer[], AxiosError>({ queryKey: ['payers'], queryFn: getPayers, staleTime: toMilliseconds({ hrs: 24 }) })
}
